module.exports = __webpack_public_path__ + "img/q_51_sor.9afe5412.png";